import { defineComponent as _defineComponent } from 'vue'
import { definePropType } from '~/utils/props';
import { mutable } from '~/utils/types';
import { onMounted, useSlots } from 'vue-demi';

interface Column {
  prop: string,
  label: string,
  aligin: 'center' | 'left' | 'right'
}



import { defineComponent } from 'vue-demi';
const __default__ = defineComponent({
  name: 'VTable'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  columns: {
    type: definePropType<Column[]>(Array),
    default: () => mutable([])
  },
  data: {
    type: definePropType<any[]>(Array),
    default: () => mutable([])
  }
},
  setup(__props) {

const slots = useSlots();



return { __sfc: true,slots }
}

})